export enum ComparisonMode {
  none = 'none',
  organization = 'organization',
  daterange = 'daterange',
}
